var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToilet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M408.81,412.406a4.157,4.157,0,0,0-3.016-1.257H368.34a4.186,4.186,0,0,0-2.991,1.257,4.085,4.085,0,0,0-1.282,3.016v37.454a4.381,4.381,0,0,0,4.273,4.273h37.454a4.085,4.085,0,0,0,3.016-1.282,4.186,4.186,0,0,0,1.257-2.991V415.422a4.157,4.157,0,0,0-1.257-3.016m-17.033,9.153a2.408,2.408,0,0,1,1.78-.74,2.544,2.544,0,0,1,2.52,2.51,2.515,2.515,0,0,1-5.03,0,2.44,2.44,0,0,1,.73-1.77m-13.35,0a2.507,2.507,0,0,1,3.55,3.54,2.525,2.525,0,0,1-4.3-1.77,2.421,2.421,0,0,1,.75-1.77m5.97,15.9h-1.65v10.02h-5.1v-10.02H376v-7.54a2.443,2.443,0,0,1,2.38-2.39h3.64a2.443,2.443,0,0,1,2.38,2.39Zm11.05,2.18v7.84h-3.77v-7.84H388.2l2.88-10.42a2.2,2.2,0,0,1,.91-1.24,2.779,2.779,0,0,1,1.57-.45,2.727,2.727,0,0,1,1.54.45,2.3,2.3,0,0,1,.94,1.24l2.88,10.42Z",
    transform: "translate(-364.067 -411.149)",
    fill: "#939598"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.1e2c6f13b948ebfebcc07d923d290323.svg";
export { ForwardRef as ReactComponent };